/** @jsxImportSource @emotion/react */
import React from 'react';
import { Form, Input, Typography } from 'antd';
import type { PlantingMetadata } from '../types';
import { formStyles } from '../constants';

interface MetadataSectionProps {
  metadata: PlantingMetadata;
}

/** Read-only display of planting creation/status metadata (edit mode only) */
const MetadataSection: React.FC<MetadataSectionProps> = ({ metadata }) => (
  <>
    <Typography.Title level={5} css={formStyles.modalTitle}>
      Данные посадки
    </Typography.Title>
    <Form.Item label="ID посадки">
      <Input value={metadata.plantingId ?? '—'} readOnly />
    </Form.Item>
    <Form.Item label="Создана">
      <Input value={metadata.createdAt ?? '—'} readOnly />
    </Form.Item>
    <Form.Item label="Создана пользователем">
      <Input value={metadata.createdBy ?? '—'} readOnly />
    </Form.Item>
    <Form.Item label="Статус обновлён">
      <Input value={metadata.statusChangedAt ?? '—'} readOnly />
    </Form.Item>
    <Form.Item label="Статус обновил пользователь">
      <Input value={metadata.statusChangedBy ?? '—'} readOnly />
    </Form.Item>
    <Typography.Title level={5} css={formStyles.sectionTitle}>
      Основные параметры
    </Typography.Title>
  </>
);

export default MetadataSection;
